import axios from 'axios'

// Custom Component
import SignOut from '../components/SignIn/SignOut'

const store = require('store')

const obtainToken = async (loginId, password) => {
	const getToken_api = '/oauth/token'
	let params = new URLSearchParams()

	try {
		params.append(
			'grant_type',
			process.env.REACT_APP_OAUTH_OBTAIN_TOKEN_GRANT_TYPE
		)

		params.append('username', loginId)
		params.append('password', password)

		const result = await axios({
			method: 'post',
			url: process.env.REACT_APP_OAUTH_OBTAIN_TOKEN_SERVER_HOST + getToken_api,
			auth: {
				username: process.env.REACT_APP_OAUTH_OBTAIN_TOKEN_CLIENT_ID,
				password: process.env.REACT_APP_OAUTH_OBTAIN_TOKEN_CLIENT_SECRET,
			},

			data: params,
		})

		return result
	} catch (error) {
		return null
	}
}

const makeSignIn = async (token) => {
	const signIn_api = '/login'

	try {
		let headers = {
			Authorization: token,
		}

		const result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3001 + signIn_api,
			headers: headers,
		})

		return result.data
	} catch (error) {
		throw new Error(error)
	}
}

const refreshToken = async () => {
	const refreshToken_api = '/oauth/token'
	let params = new URLSearchParams()

	try {
		params.append(
			'grant_type',
			process.env.REACT_APP_OAUTH_REFRESH_TOKEN_GRANT_TYPE
		)

		params.append('refresh_token', store.get('refresh_token'))

		const result = await axios({
			method: 'post',
			url:
				process.env.REACT_APP_OAUTH_REFRESH_TOKEN_SERVER_HOST +
				refreshToken_api,
			auth: {
				username: process.env.REACT_APP_OAUTH_REFRESH_TOKEN_CLIENT_ID,
				password: process.env.REACT_APP_OAUTH_REFRESH_TOKEN_CLIENT_SECRET,
			},

			data: params,
		})

		return result
	} catch (error) {
		if (error.response.status === 401) {
			SignOut()
		} else {
			throw new Error(error)
		}
	}
}

// const oidcCallBack = async (queryString) => {
//   const signIn_api = `http://172.16.145.82:3001/cms/api/v1/login/oidc/auth/callback${queryString}`;
//   try {
//     const result = await axios({
//       method: "get",
//       url: signIn_api,
//     });

//     return result.data;
//   } catch (error) {
//     throw new Error(error);
//   }
// };

const oidcSignIn = async (code, state) => {
	let params = new URLSearchParams()

	try {
		params.append('code', code)
		params.append('state', state)
		params.append('redirect_uri', process.env.REACT_APP_OIDC_REDIRECT_URI)

		const result = await axios({
			method: 'get',
			url: process.env.REACT_APP_OIDC_CALLBACK_API,
			params: params,
		})

		return result.data
	} catch (error) {
		throw new Error(error)
	}
}

const getUserData = async (token) => {
	const getUserData_api = '/login'

	try {
		let headers = {
			Authorization: token,
		}

		const result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3001 + getUserData_api,
			headers: headers,
		})

		return result.data
	} catch (error) {
		throw new Error(error)
	}
}

export { obtainToken, makeSignIn, refreshToken, oidcSignIn, getUserData }
